<script setup lang="ts">
import { ref, type PropType } from 'vue';
import { type FormField } from '@/models/form';
import { ButtonType, CustomButton, CustomSlider } from '@/components';
import { useI18n } from 'vue-i18n';

const { t: $t } = useI18n();

const props = defineProps({
  field: {
    type: Object as PropType<FormField>,
    required: true
  },
  previewMode: {
    type: Boolean
  }
});

const localField = ref<FormField>(props.field);

if (localField.value.numberValue === undefined && localField.value.default) {
  localField.value.numberValue = Number(localField.value.default);
}

const resetSliderValue = () => {
  localField.value.numberValue = undefined;
};
</script>

<template>
  <div class="item-root">
    <CustomSlider v-model="localField.numberValue as number | undefined"
      :min="localField.options.startValue!"
      :max="localField.options.endValue!"
      :incrementSize="localField.options.incrementSize!"
      :startLabel="localField.options.startLabel!"
      :endLabel="localField.options.endLabel!"
      :disabled="previewMode"
      valueBadge/>
    <CustomButton :text="$t('reset')"
      @onClick="resetSliderValue"
      class="reset-button"
      v-if="localField.numberValue !== undefined && !previewMode"
      :type="ButtonType.OUTLINED"/>
  </div>
</template>
